import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
const BONUSES = [{
  num: 'BONO 1',
  title: 'Kit Profesional para Empezar',
  image: 'https://cdn.magicpatterns.com/uploads/ot2WTMJng8PVVoVNGHyjPg/ChatGPT_Image_6_mar_2026,_18_59_41.png',
  alt: 'Bono 1: Kit Profesional',
  items: ['herramientas básicas del instalador', 'tipos de cámaras más utilizadas', 'grabadores recomendados', 'cables, conectores y fuentes', 'lista de compra para tu primera instalación'],
  objetivo: 'Evitar que compres equipos incorrectos y ayudarte a empezar con más claridad.'
}, {
  num: 'BONO 2',
  title: 'Instalaciones Reales Paso a Paso',
  image: 'https://cdn.magicpatterns.com/uploads/2nr8vp1JyE4Xo9uoVyZbHV/ChatGPT_Image_6_mar_2026,_19_11_27.png',
  alt: 'Bono 2: Instalaciones Reales',
  items: ['instalación completa en casa', 'instalación en comercio', 'instalación exterior', 'cableado, configuración y acceso remoto'],
  objetivo: 'Que veas cómo se aplica todo en situaciones reales.'
}, {
  num: 'BONO 3',
  title: 'Cómo Conseguir Tus Primeros Clientes',
  image: 'https://cdn.magicpatterns.com/uploads/8BaptCRwSeWTERHYLggwcp/ChatGPT_Image_6_mar_2026,_19_19_59.png',
  alt: 'Bono 3: Primeros Clientes',
  items: ['cómo ofrecer el servicio desde cero', 'cómo hablar con clientes', 'cómo usar Facebook Marketplace y grupos', 'cómo conseguir recomendaciones'],
  objetivo: 'Ayudarte a pasar de aprender a empezar a trabajar.'
}];
export function BonusSection() {
  return <section className="bg-[#0a1628] py-16 md:py-24 px-4 text-white relative" data-id="element-15">
      {/* Decorative glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-yellow-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-16"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-17">
        <div className="text-center mb-12" data-id="element-18">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-yellow-500/10 border border-yellow-500/30 mb-6 shadow-[0_0_20px_rgba(234,179,8,0.15)]" data-id="element-19">
            <GiftIcon className="w-8 h-8 text-yellow-400" data-id="element-20" />
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-yellow-500 mb-3 uppercase drop-shadow-sm" data-id="element-21">
            Y ESO NO ES TODO...
          </h2>
          <p className="text-xl md:text-2xl font-bold text-white uppercase tracking-wide" data-id="element-22">
            HOY TAMBIÉN RECIBÍS ESTOS 3 BONOS ESPECIALES
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-23">
          {BONUSES.map((bonus, idx) => <div key={idx} className="bg-[#0f1d32] rounded-2xl border border-blue-900/40 overflow-hidden flex flex-col relative group hover:border-yellow-500/30 transition-colors duration-300 shadow-xl" data-id="element-24">
              {/* Animated Gratis Banner */}
              <div className="bg-gradient-to-r from-red-600 via-red-500 to-red-600 text-white py-2 px-4 text-center relative overflow-hidden" data-id="element-25">
                <div className="absolute inset-0 bg-[linear-gradient(45deg,transparent_25%,rgba(255,255,255,0.2)_50%,transparent_75%)] bg-[length:250%_250%,100%_100%] animate-[shimmer_2s_infinite]" data-id="element-26"></div>
                <span className="font-black text-sm tracking-widest uppercase relative z-10 flex items-center justify-center gap-2" data-id="element-27">
                  <GiftIcon className="w-4 h-4" data-id="element-28" />
                  GRATIS POR HOY
                </span>
              </div>

              <a href="https://pagos.avanzalab.online/cart/53128638628154:1" className="block hover:scale-[1.03] transition-transform duration-500 p-4 pb-0 relative" data-id="element-29">
                <div className="absolute inset-0 bg-blue-500/10 blur-xl rounded-full transform scale-75 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-30"></div>
                <img src={bonus.image} alt={bonus.alt} className="w-full object-contain rounded-xl shadow-lg max-h-52 mx-auto border border-blue-900/30 relative z-10" data-id="element-31" />
              </a>

              <div className="p-5 flex flex-col flex-grow" data-id="element-32">
                <div className="inline-block bg-yellow-500/10 border border-yellow-500/30 text-yellow-400 font-black text-xs px-2 py-1 rounded mb-3 uppercase self-start" data-id="element-33">
                  {bonus.num}
                </div>
                <h4 className="text-lg font-bold text-white mb-4 leading-snug" data-id="element-34">
                  {bonus.title}
                </h4>

                <ul className="space-y-2 mb-5 flex-grow" data-id="element-35">
                  {bonus.items.map((item, i) => <li key={i} className="flex items-start" data-id="element-36">
                      <CheckIcon className="w-4 h-4 text-green-400 mr-2 flex-shrink-0 mt-0.5" data-id="element-37" />
                      <span className="text-gray-300 text-sm leading-relaxed" data-id="element-38">
                        {item}
                      </span>
                    </li>)}
                </ul>

                <div className="bg-[#060e1a] p-3.5 rounded-xl border border-blue-900/40 mt-auto relative overflow-hidden" data-id="element-39">
                  <div className="absolute left-0 top-0 bottom-0 w-1 bg-yellow-500" data-id="element-40"></div>
                  <p className="text-gray-300 italic text-xs leading-relaxed pl-2" data-id="element-41">
                    <span className="font-bold text-yellow-400 block mb-1 not-italic" data-id="element-42">
                      Objetivo:{' '}
                    </span>
                    {bonus.objetivo}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}